import { useSearchParams } from 'react-router-dom';

import { ROUTE_CONSTANTS } from '../constants/routes';

/**
 * Gets the blueprintID search param from the url and sets a string value to it
 *
 * @returns An object with the blueprintID and setBlueprintID params
 *
 * @example
 * ```tsx
 * const { blueprintID, setBlueprintID } = useBlueprintIDSearchParam();
 * ```
 */
export const useBlueprintIDSearchParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setBlueprintID = (blueprintID: string) =>
    setSearchParams({
      [ROUTE_CONSTANTS.BLUEPRINT_ID_SEARCH_PARAM]: blueprintID,
    });

  return {
    blueprintID: searchParams.get(ROUTE_CONSTANTS.BLUEPRINT_ID_SEARCH_PARAM),
    setBlueprintID,
  };
};
